export function BArecordMark({ size = 20, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      aria-hidden="true"
      data-testid="barecord-mark"
    >
      <rect x="1.5" y="1.5" width="19" height="19" rx="5.5" stroke="currentColor" strokeWidth="1.3" />
      <path d="M6.5 7.5h9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M6.5 11h9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M6.5 14.5h4.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="15.2" cy="14.5" r="1.4" fill="currentColor" />
    </svg>
  );
}
